/* eslint-disable @typescript-eslint/no-explicit-any */
import { HORSE_POPUP_ARMOR } from 'assets/images'
import styled from 'styled-components'

interface HorseBloodlineStyleProps {
  width?: any
  height?: any
}

const HorseBloodlineStyle = styled.div<HorseBloodlineStyleProps>`
  position: relative;
  width: ${({ width }) => width + 'px'};
  min-height: ${({ height }) => height + 'px'};
  background: url(${HORSE_POPUP_ARMOR});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  z-index: 99;
  padding: 25px 32px 30px;

  .close-btn {
    top: 29px;
    right: 29px;
    background-color: ${({ theme }) => theme.color.transparent};
    border: none;
    z-index: 100;
  }

  .content-box {
    position: relative;
    display: flex;
    flex-direction: column;
    color: #fff;
    font-size: 18px;
    line-height: 38px;

    .information {
      margin-top: 6px;
      padding-left: 6px;

      .content{
        white-space-collapse: preserve-breaks;

        p{
          margin-bottom: 0px;
        }
      }

      .information-box {
        display: flex;
        gap: 20px;
        font-size: 18px;

        .active {
          position: relative;
          color: #4ef076;
          font-weight: 600;
          line-height: 24px;

          .line-text {
            position: absolute;
            width: 100%;
            height: 1px;
            bottom: 0px;
            left: 50%;
            transform: translate(-50%);
          }
        }
      }
    }
  }

  .loading__item {
    position: absolute;
    top: 50%;
    left: 50%;

    .ant-spin {
      .ant-spin-dot-item {
        background-color: #4bf296;
      }
    }
  }

  .attribute__item {
    display: inline-block;
    min-width: 66px;
  }
`

export { HorseBloodlineStyle }
